<template>
  <div>
    <h1 v-on:click="isFolded = !isFolded">
      <i
        class="fas el-icon-fa-caret-right"
        :style="{transform: 'rotate(' + (isFolded ? '0' : '90') + 'deg)'}"
      />
      {{ isResponse ? "Response" : "Request" }}
      <HttpStatusCode v-if="isResponse" :code="statusCode"/>
    </h1>
    <transition name="el-zoom-in-top">
      <el-row v-if="!isFolded" :gutter="20" type="flex">
        <el-col :span="8">
          <el-table stripe :data="headersTableData" :cell-style="cellStyle">
            <el-table-column min-width="40" prop="key" label="Key" align="right" />
            <el-table-column min-width="60" prop="value" label="Value" />
          </el-table>
        </el-col>
        <el-col :span="16">
          <div class="editor-container">
            <MonacoEditor
              v-if="bodyLinted"
              class="editor"
              v-model="bodyLinted"
              :language="bodyLanguage"
              :options="editorOptions"
              theme="drhttp"
            />
            <div class="empty-body" v-if="!bodyLinted">
              <i class="fas el-icon-fa-ban" size="big" />
              <div>Empty body</div>
            </div>
            <el-button
            class="lint-button"
              type="primary"
              icon="fas el-icon-fa-stream"
              @click="lintButtonTapped"
              :plain="!isLinted"
              size="small"
            />
          </div>
        </el-col>
      </el-row>
    </transition>
  </div>
</template>
      
<script>
import { Base64 } from "js-base64";
import MonacoEditor from "vue-monaco-d0x";
import vkbeautify from "vkbeautify";

import HttpStatusCode from "@/components/HttpStatusCode.vue";

import colors from "@/assets/styles/colors.sass";

export default {
  components: {
    HttpStatusCode,
    MonacoEditor
  },
  props: {
    content: {
      required: true
    },
    isResponse: {
      default: false
    },
    statusCode: {
      required: false
    }
  },
  data: function() {
    return {
      isFolded: false,
      isLinted: true
    };
  },
  computed: {
    headersTableData: function() {
      var resp = [];
      for (let header in this.content.headers) {
        resp.push({ key: header + " :", value: this.content.headers[header] });
      }
      return resp;
    },
    bodyDecoded: function() {
      return Base64.decode(this.content.body);
    },
    bodyLanguage: function() {
      for (let header in this.content.headers) {
        if (header.toLowerCase() == "content-type") {
          let components = this.content.headers[header]
            .split(";")[0]
            .split("/")[1]
            .split("+");
          let types = ["json", "html", "xml", "css"];
          for (var i in types) {
            if (components.includes(types[i])) {
              return types[i];
            }
          }
        }
      }
      return null;
    },
    bodyLinted: function() {
      let indentation = "  ";
      let placeholder = null;

      if (this.bodyDecoded.length == 0) {
        return placeholder;
      }
      if (!this.isLinted) {
        return this.bodyDecoded;
      }
      switch (this.bodyLanguage) {
        case "json":
          return vkbeautify.json(this.bodyDecoded, indentation);
        case ("xml", "html"):
          return vkbeautify.xml(this.bodyDecoded, indentation);
        case "css":
          return vkbeautify.css(this.bodyDecoded, indentation);
        default:
          return this.bodyDecoded;
      }
    },
    editorOptions: function() {
      return {  // doc : https://microsoft.github.io/monaco-editor/api/interfaces/monaco.editor.ieditorconstructionoptions.html
        autoIndent: true,
        automaticLayout: true,
        codeLens: false,
        contextmenu: false,
        lightbulb: {
          enabled: false
        },
        matchBrackets: false,
        minimap: {
          enabled: false
        },
        overviewRulerBorder: false,
        readOnly: true,
        showFoldingControls: 'always',
        fontFamily: "Recursive"
      };
    }
  },
  methods: {
    cellStyle: function({ row, column, rowIndex, columnIndex }) {
      return (
        '\
        font-family: "Recursive" !important;\
        color: ' +
        colors[columnIndex == 0 ? "primary" : "secondary"] +
        ";\
        padding-top: 5px;\
        padding-bottom: 5px;\
      "
      );
    },
    lintButtonTapped: function(event) {
      this.isLinted = !this.isLinted;
      event.target.blur();
    }
  }
};
</script>

<style scoped lang="sass">
.editor-container
  width: 100%
  height: 100%
  min-height: 500px
  border-radius: 4px
  overflow: hidden    // clip children corners

.editor
  height: 100%
  min-height: 400px

.empty-body
  width: 100%
  height: 100%

  background: $color-primary-light
  color: $color-secondary-light
  flex-direction: column
  @include flex($h: center, $v: center)

  i
    font-size: 4em
    margin-bottom: 25px

  div
    font-size: 1.5em

.lint-button
  position: absolute
  top: 5px
  right: 30px

</style>